import { render, staticRenderFns } from "./SearchingPlaceholder.vue?vue&type=template&id=b57d4294&scoped=true&"
import script from "./SearchingPlaceholder.vue?vue&type=script&lang=js&"
export * from "./SearchingPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./SearchingPlaceholder.vue?vue&type=style&index=0&id=b57d4294&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b57d4294",
  null
  
)

export default component.exports